import { render, staticRenderFns } from "./nacional.vue?vue&type=template&id=3e095d2a&scoped=true"
import script from "./nacional.vue?vue&type=script&lang=js"
export * from "./nacional.vue?vue&type=script&lang=js"
import style0 from "./ranking.css?vue&type=style&index=0&id=3e095d2a&prod&scoped=true&lang=css&external"
import style1 from "./nacional.vue?vue&type=style&index=1&id=3e095d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e095d2a",
  null
  
)

export default component.exports